module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1253.27c5aad6.png";